<div class="password-reset-wrapper">
  <mat-card class="password-reset-card">
    <mat-card-header class="password-reset-header">
      <div class="logo" role="img" aria-label="Damotech"></div>
      <div class="title">{{ 'passwordreset.title' | translate }}</div>
      <div class="description">{{ 'passwordreset.description' | translate }}</div>
    </mat-card-header>

    <div class="password-reset-content">
      <mat-card-content>
        @if (successMessage()) {
          <p class="success-message">{{ successMessage() }}</p>
        } @else {
          <form [formGroup]="form" (ngSubmit)="onSubmit()">
            <div class="fields">
              <mat-form-field appearance="outline">
                <mat-label>{{ 'passwordreset.email.title' | translate }}</mat-label>
                <input matInput type="email" formControlName="email" autocomplete="email" />
                <mat-icon matPrefix>email</mat-icon>
              </mat-form-field>

              <mat-form-field appearance="outline">
                <mat-label>{{ 'passwordreset.password.title' | translate }}</mat-label>
                <input matInput type="password" formControlName="password" autocomplete="new-password" />
                <mat-icon matPrefix>lock</mat-icon>
                @if (form.get('password')?.hasError('required') && form.get('password')?.touched) {
                  <mat-error>{{ 'passwordreset.password.required' | translate }}</mat-error>
                } @else if (form.get('password')?.touched && form.get('password')?.invalid) {
                  <mat-error>{{ 'passwordreset.password.complexity' | translate }}</mat-error>
                }
              </mat-form-field>

              <mat-form-field appearance="outline">
                <mat-label>{{ 'passwordreset.password.repeat.title' | translate }}</mat-label>
                <input matInput type="password" formControlName="passwordRepeat" autocomplete="new-password" />
                <mat-icon matPrefix>lock</mat-icon>
                @if (form.get('passwordRepeat')?.hasError('required') && form.get('passwordRepeat')?.touched) {
                  <mat-error>{{ 'passwordreset.password.repeat.required' | translate }}</mat-error>
                } @else if (form.get('passwordRepeat')?.touched && form.get('passwordRepeat')?.hasError('match')) {
                  <mat-error>{{ 'passwordreset.password.repeat.match' | translate }}</mat-error>
                }
              </mat-form-field>

              @if (errorMessage()) {
                <p class="error-message">{{ errorMessage() }}</p>
              }
            </div>

            <button
              mat-flat-button
              color="primary"
              type="submit"
              class="btn"
              [disabled]="loading()"
            >
              @if (loading()) {
                <mat-spinner diameter="20" />
              } @else {
                {{ 'passwordreset.submit' | translate }}
              }
            </button>
          </form>
        }
      </mat-card-content>

      <mat-card-actions class="password-reset-actions">
          @if (redirectUrl() && successMessage()) {
            <button mat-flat-button color="primary" type="button" class="btn" (click)="proceedAfterReset()">
              {{ 'passwordreset.continue' | translate }}
            </button>
          }
        <div class="back">
          <a mat-button [routerLink]="['../', DAMO_AUTH_PATHS.SIGN_IN]" class="back-to-sign-in-link">
            {{ 'passwordreset.backtosignin' | translate }}
          </a>
        </div>
        
      </mat-card-actions>
    </div>
  </mat-card>
</div>
